query AnalyticsSalesByProduct($filter: AnalyticsSalesFilterInput!, $limit: Int) {
  analyticsSales(filter: $filter) {
    currency
    salesByProduct(limit: $limit) {
      productId
      title
      sales
      revenue
    }
  }
}
